import io from 'socket.io-client'

// Use window.location.origin to automatically use correct domain
export const socket = io(window.location.origin)
